// extracted by mini-css-extract-plugin
export default {"container":"PageSkeleton_container__BNYVW"};